module.exports = __webpack_public_path__ + "img/198.33107ecf.jpg";